module.exports = __webpack_public_path__ + "img/calendar.95095184.svg";